var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"height":"2","rx":"1","width":"24","key":0}),React.createElement("rect",{"height":"2","rx":"1","width":"24","y":"7","key":1}),React.createElement("rect",{"height":"2","rx":"1","width":"24","y":"14","key":2})]));
}

HamburgerMenu.defaultProps = {"height":"16","viewBox":"0 0 24 16","width":"24"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
